export default __webpack_public_path__ + "static/media/UsingDrawing.f91521d3.mp4";